import {Component, Input, ViewChild} from '@angular/core';
import {getMappedColoredYarnSet} from '@application/helper/textile-data/colored-yarn-set/get-mapped-colored-yarn-set';
import {PositionOfDialog} from '@domain/position-of-dialog';
import {CreelMap} from '@domain/textile-data/creel/creel-map';
import {OverviewListColoredYarnSetWithStartDent} from '@domain/textile-data/creel/overview-list-colored-yarn-set-with-start-dent';
import {ColorListPreviewComponent} from '@presentation/components/color-list-preview/color-list-preview.component';
import {OverviewListColoredYarnSet} from '@presentation/pages/textile-data/colored-yarn-set/overview/overview-list-colored-yarn-set';

@Component({
  selector: 'app-color-list-preview-with-position',
  templateUrl: './color-list-preview-with-position.component.html',
  styleUrls: ['./color-list-preview-with-position.component.scss']
})
export class ColorListPreviewWithPositionComponent {
  @Input() public isSisal: boolean;
  @Input() public coloredYarnSet: OverviewListColoredYarnSetWithStartDent;
  @Input() public creelMapping: CreelMap;
  @ViewChild('colorListPreview') public colorListPreview: ColorListPreviewComponent;

  public readonly dialogPosition = PositionOfDialog.RIGHT;

  public calculateCreelPositionsToShow(): void {
    this.colorListPreview.calculateCreelPositionsToShow();
  }

  public getColorList(coloredYarnSet: OverviewListColoredYarnSet): OverviewListColoredYarnSet {
    return getMappedColoredYarnSet(coloredYarnSet, this.creelMapping, 'asc');
  }
}
